<template>
  <div class="store-card-skeleton">
    <!-- Header do Card -->
    <div class="skeleton-header">
      <div class="skeleton-title">
        <div class="skeleton-line title-line"></div>
        <div class="skeleton-line subtitle-line"></div>
      </div>
      <div class="skeleton-icons">
        <div class="skeleton-icon"></div>
        <div class="skeleton-icon"></div>
        <div class="skeleton-icon"></div>
        <div class="skeleton-badge"></div>
      </div>
    </div>

    <!-- Conteúdo do Card -->
    <div class="skeleton-content">
      <!-- Status de Atualização -->
      <div class="skeleton-status">
        <div class="skeleton-line status-line"></div>
      </div>

      <!-- Nível de Estoque -->
      <div class="skeleton-stock">
        <div class="skeleton-line stock-text"></div>
        <div class="skeleton-progress">
          <div class="skeleton-progress-fill"></div>
        </div>
      </div>

      <!-- Informações do Produto -->
      <div class="skeleton-product-info">
        <div class="skeleton-info-item">
          <div class="skeleton-icon-small"></div>
          <div class="skeleton-line info-line"></div>
        </div>
        <div class="skeleton-info-item">
          <div class="skeleton-icon-small"></div>
          <div class="skeleton-line info-line"></div>
        </div>
      </div>

      <!-- Abas de Período -->
      <div class="skeleton-tabs">
        <div class="skeleton-tab active"></div>
        <div class="skeleton-tab"></div>
        <div class="skeleton-tab"></div>
      </div>

      <!-- Dados de Vendas -->
      <div class="skeleton-sales-data">
        <div class="skeleton-data-row">
          <div class="skeleton-data-label"></div>
          <div class="skeleton-data-label"></div>
          <div class="skeleton-data-label"></div>
        </div>
        <div class="skeleton-data-row">
          <div class="skeleton-data-value"></div>
          <div class="skeleton-data-value"></div>
          <div class="skeleton-data-value"></div>
        </div>
      </div>

      <!-- Botões de Ação -->
      <div class="skeleton-action-buttons">
        <div class="skeleton-action-btn"></div>
        <div class="skeleton-action-btn"></div>
        <div class="skeleton-action-btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreCardSkeleton'
}
</script>

<style scoped>
.store-card-skeleton {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: skeletonPulse 1.5s ease-in-out infinite;
}

@keyframes skeletonPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Header */
.skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.skeleton-title {
  flex: 1;
}

.title-line {
  width: 80%;
  height: 20px;
  margin-bottom: 8px;
}

.subtitle-line {
  width: 60%;
  height: 14px;
}

.skeleton-icons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.skeleton-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e9ecef;
}

.skeleton-badge {
  width: 60px;
  height: 24px;
  border-radius: 12px;
  background: #e9ecef;
}

/* Conteúdo */
.skeleton-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.skeleton-line {
  background: #e9ecef;
  border-radius: 4px;
  animation: skeletonShimmer 1.5s ease-in-out infinite;
}

@keyframes skeletonShimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}

/* Status */
.status-line {
  width: 70%;
  height: 16px;
}

/* Estoque */
.skeleton-stock {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stock-text {
  width: 90%;
  height: 16px;
}

.skeleton-progress {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.skeleton-progress-fill {
  width: 65%;
  height: 100%;
  background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
  background-size: 200px 100%;
  animation: skeletonShimmer 1.5s ease-in-out infinite;
}

/* Informações do Produto */
.skeleton-product-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.skeleton-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.skeleton-icon-small {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #e9ecef;
}

.info-line {
  width: 60%;
  height: 14px;
}

/* Abas */
.skeleton-tabs {
  display: flex;
  gap: 8px;
}

.skeleton-tab {
  flex: 1;
  height: 32px;
  background: #e9ecef;
  border-radius: 16px;
}

.skeleton-tab.active {
  background: #007bff;
}

/* Dados de Vendas */
.skeleton-sales-data {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-data-row {
  display: flex;
  justify-content: space-between;
}

.skeleton-data-label,
.skeleton-data-value {
  width: 25%;
  height: 16px;
  background: #e9ecef;
  border-radius: 4px;
}

/* Botões de Ação */
.skeleton-action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.skeleton-action-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e9ecef;
}

/* Responsividade */
@media (max-width: 768px) {
  .store-card-skeleton {
    padding: 16px;
  }

  .skeleton-header {
    margin-bottom: 16px;
  }

  .skeleton-content {
    gap: 12px;
  }

  .title-line {
    height: 18px;
  }

  .subtitle-line {
    height: 12px;
  }

  .skeleton-icon {
    width: 18px;
    height: 18px;
  }

  .skeleton-badge {
    width: 50px;
    height: 20px;
  }
}

/* Tema escuro */
@media (prefers-color-scheme: dark) {
  .store-card-skeleton {
    background: #343a40a8;
    /* background: #343a40; */
    border-color: #495057;
  }

  .skeleton-line,
  .skeleton-icon,
  .skeleton-badge,
  .skeleton-progress,
  .skeleton-data-label,
  .skeleton-data-value,
  .skeleton-action-btn {
    background: #343a4042;
  }

  .skeleton-tab {
    /* background: #495057;
     */
    background: #343a4042;
  }

  .skeleton-tab.active {
    /* background: #007bff; */
    background: #007bff7a;
  }
}
</style>
